// LoginForm.js
import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Typography } from '@mui/material';
import { AuthContext } from '../AuthContextProvider';
import ErrorDialog from '../ErrorDialog';
import '../App.css';

const LoginForm = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { login, setLoginRole} = useContext(AuthContext);
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const creds = new URLSearchParams();
      creds.append('login', username);
      creds.append('password', password);
      creds.append('version', 350);
      const response = await fetch('/itvs-site/login', {
        method: "post",
        headers : {
          'Accept': 'application/json'
        },
        body: creds,
      });
      const user = await response.json();
      if (user.error) {
        setErrorMessage(user.error.message);
        setOpenErrorDialog(true);
      } else {
        login(user);
        if (user.roles.length > 1) {
          navigate("/setRole");
        } else if (user.roles.length === 1) {
          setLoginRole(user, user.roles[0]);
          navigate('/home');
        } else {
          throw new Error("User has no roles");
        }
      }
    } catch (err) {
      console.error(err);
      setErrorMessage(`failed to set role ${err}`);
      setOpenErrorDialog(true);
    }
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="LoginForm">
      <Typography variant="h6" gutterBottom>
        Login
      </Typography>
      <TextField className="TextField"
        label="Username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        margin="normal"
      />
      <TextField className="TextField"
        type="password"
        label="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        margin="normal"
      />
      <Button className="Button" variant="contained" color="primary" onClick={handleLogin}>
        Login
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default LoginForm;
